import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminListVpsUsByUserComponent from "../../../components/Admin/users/AdminListVpsUsByUserComponent";

const AdminListVpsUsByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <AdminListVpsUsByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default AdminListVpsUsByUserPage;